import { StorageResourceLocation } from '../../data/specialized/storage/storage.location';
import { interpolate } from '../../functions/interpolate.function';
import { ReadonlyRepository } from '../abstraction';
import { StorageDataAccess } from '../../data-access/abstraction/storage.data-access';

export abstract class ReadonlyStorageRepository<TResult, TParams> implements ReadonlyRepository<TResult | null, TParams> {

  protected constructor(protected dataAccess: StorageDataAccess,
                        protected key: string) { }

  async load(params: TParams): Promise<TResult | null> {
    const location: StorageResourceLocation = {
      key: this.getKey(params)
    };
    return this.dataAccess.get(location);
  }

  protected getKey(params: TParams): string {
    return interpolate(this.key, params ?? {});
  }
}
